import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { PendingVehicleAssignmentsService } from 'app/modules/vehicle-inventory/services/pending-vehicle-assignments.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { CecoService } from 'app/rest/ceco.service';
import { Rest } from 'app/rest/rest_client';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService } from 'primeng/api';
import { PendingVehicleAssignmentsFormComponent } from '../pending-vehicle-assignments-form/pending-vehicle-assignments-form.component';

@Component({
    selector: 'app-pending-vehicle-assignments-list',
    templateUrl: './pending-vehicle-assignments-list.component.html',
    styleUrls: ['./pending-vehicle-assignments-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PendingVehicleAssignmentsListComponent extends EntityListComponent<Rest.InvPendingVehicleAssignment> implements OnInit {

    @Input() vehicle: Rest.Vehicle = null;

    canDelete: boolean = false;
    companiesList: Rest.BillingAccount[] = [];
    delegationList: Rest.Delegation[] = [];
    subdelegationList: Rest.Subdelegation[] = [];
    cecoList: Rest.Ceco[] = [];

    @ViewChild(PendingVehicleAssignmentsFormComponent, { static: true })
    pendingVehicleAssignmentsForm: PendingVehicleAssignmentsFormComponent;

    constructor(
        protected pendingVehicleAssignmentsService: PendingVehicleAssignmentsService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService,
        public invVehicleService: InvVehicleService,
        public delegationService: DelegationService,
        public subdelegationService: SubdelegationService,
        public cecoService: CecoService,
    ) {
        super(
            pendingVehicleAssignmentsService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.pendingVehicleAssignmentsForm;
        this.user = this.authenticationService.user;
        this.canDelete = this.authenticationService.isRoleGranted('INV_VEHICLE_ASSIGNMENTS_DELETE', this.user);
        this.getBillingAccounts(this.user.client.id);
        this.getDelegationList(this.user.client.id);
        this.getSubdelegationList(this.user.client.id);
        this.getCecoList();
    }

    beforeLoad(): void {
        if (this.vehicle) {
            this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];
        }
        if (!this.paginationRequest.filters['status']) {
            this.paginationRequest.filters['status'] = ['false'];
        }
        if (!this.paginationRequest.sortBy) {
            this.paginationRequest.sortBy = 'startDate';
            this.paginationRequest.sortAsc = false;
        }
    }

    afterLoad(): void {}

    public onDeleteAssignment(p: Rest.InvPendingVehicleAssignment) {
        this.confirmationService.confirm({
            accept: () => {
                this.pendingVehicleAssignmentsService.deleteAssignment(p.id).then(
                    () => {
                        this.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
                        this.refresh();
                    },
                    () => this.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'))
                );
            },
            key: 'pending-vehicle-assignments-list'
        });
    }

    public getBillingAccounts(clientId: number) {
        this.invVehicleService.getBillingAccounts(clientId).then(
            (response: Rest.BillingAccount[]) => { this.companiesList = response; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }

    public getDelegationList(clientId: number) {
        this.delegationService.getList(clientId).then(
            (response: Rest.Delegation[]) => { this.delegationList = response; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }

    public getSubdelegationList(clientId: number) {
        this.subdelegationService.getListByClient(clientId).then(
            (response: Rest.Subdelegation[]) => { this.subdelegationList = response; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }

    public getCecoList() {
        const req = {
            sortBy: null, sortAsc: true, pageSize: 2147483647, filters: {}, loadPermissions: false
        } as unknown as Rest.ListPaginationRequest;
        this.cecoService.getPage(req).then(
            (response: Rest.Page<Rest.Ceco>) => { this.cecoList = response.entities; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }
}
